import { makeObservable, action, observable } from "mobx";
class CardManagerStore {
  timeout = void 0;
  resultNotice = "NO_NOTICE";
  resultNoticeLabelKey = "";
  cardManagerView = false;
  constructor() {
    makeObservable(this, {
      timeout: observable,
      resultNotice: observable,
      resultNoticeLabelKey: observable,
      cardManagerView: observable,
      createTimeoutForResultNotice: action,
      clearTimeout: action,
      setResultNotice: action,
      resetResultNotice: action,
      setResultNoticeLabelKey: action,
      setCardManagerView: action
    });
  }
  showCardSavingResultNotice(paymentStatus) {
    this.setResultNotice(paymentStatus, "save");
    this.createTimeoutForResultNotice();
  }
  showCardDeleteErrorNotice() {
    this.setResultNotice("ERROR", "delete");
    this.createTimeoutForResultNotice();
  }
  showCardDeleteSuccessNotice() {
    this.setResultNotice("COMPLETED", "delete");
    this.createTimeoutForResultNotice();
  }
  createTimeoutForResultNotice() {
    if (this.timeout) {
      this.clearTimeout();
    }
    this.timeout = setTimeout(() => {
      this.resetResultNotice();
    }, 5e3);
  }
  clearTimeout() {
    clearTimeout(this.timeout);
    this.timeout = void 0;
  }
  setResultNotice(paymentStatus, actionType) {
    if (paymentStatus === "COMPLETED") {
      this.resultNotice = "SUCCESS";
      this.setResultNoticeLabelKey(
        actionType,
        "payment.card-manager.saving-card.success",
        "payment.card-manager.deleting-card.success"
      );
    } else if (["ERROR", "REJECTED"].includes(paymentStatus)) {
      this.resultNotice = "ERROR";
      this.setResultNoticeLabelKey(
        actionType,
        "payment.card-manager.saving-card.error",
        "payment.card-manager.deleting-card.error"
      );
    }
  }
  resetResultNotice() {
    this.resultNotice = "NO_NOTICE";
  }
  setResultNoticeLabelKey(actionType, savingLabelKey, deletingLabelKey) {
    if (actionType === "save") {
      this.resultNoticeLabelKey = savingLabelKey;
    } else if (actionType === "delete") {
      this.resultNoticeLabelKey = deletingLabelKey;
    }
  }
  setCardManagerView(cardManagerView) {
    this.cardManagerView = cardManagerView;
  }
  clearNoticeTimeoutIfNeeded() {
    if (this.resultNotice === "NO_NOTICE" && this.timeout) {
      this.clearTimeout();
    }
  }
}
export {
  CardManagerStore as default
};
